import React from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

import useGetMyChats from '../../../services/hookService/chats/getMyChats/useGetMyChats';
import InfinitScroll from '../../../components/infinitScroll';
import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import useGetUnSeenChat from '../../../services/hookService/getUnSeenChat/getUnSeenChat';
import ChatItem from './chatList/chatItem';

const MyChats = () => {
  const {data, hasNextPage, isLoading, fetchNextPage} = useGetMyChats();
  const {data: unSeenNotificationData} = useGetUnSeenChat();

  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader
        title={'پیام‌ها'}
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
        backRoute="/"
        postComponent={() => (
          <div className="relative">
            <i className={`icon-namechat text-[25px] text-gray-700`} />
            {unSeenNotificationData !== undefined &&
              unSeenNotificationData !== null &&
              unSeenNotificationData.unseen_count !== 0 && (
                <span className="h-[12px] flex items-center justify-center w-[12px] absolute text-white text-xs rounded-full bg-red-700 right-0 bottom-[5px]">
                  {unSeenNotificationData.unseen_count}
                </span>
              )}
          </div>
        )}
      />

      <div className="w-full h-full py-2 px-3 bg-white  overflow-y-auto">
        {!data ||
          (data?.pages?.flatMap(x => x.results).length === 0 && (
            <div className="flex pt-5 gap-2 justify-center items-center flex-col w-full h-full ">
              <img
                loading="lazy"
                width={142}
                height={70}
                src="https://s3.ir-thr-at1.arvanstorage.ir/my-chats/empty-chats.svg"
                alt="empty msg"
              />
              <p className="text-gray-900 font-Regular">
                هیچ پیامی ندارید :{'('}
              </p>
            </div>
          ))}
        <InfinitScroll
          isloading={isLoading}
          onWatchEnd={() => {
            hasNextPage && !isLoading && fetchNextPage();
          }}
        >
          {data?.pages
            .flatMap(x => x.results)
            ?.map((item, index) => {
              return (
                <div
                  className="py-2 mt-1 border-b-[1px] border-gray-100 "
                  key={index}
                >
                  <ChatItem
                    count_msg={item.chat_detail?.unseen_count}
                    image={item.contact_detail?.profile_image}
                    id={item?.guid}
                    optionsChatItem={[]}
                    created_at={item.chat_detail?.created_at}
                    name={item.contact_detail?.name}
                    is_online={item.chat_detail?.is_online}
                    last_message_text={item.chat_detail?.last_message}
                  />
                </div>
              );
            })}
        </InfinitScroll>
      </div>

      <MainFooter />
    </div>
  );
};

export default MyChats;
